import { useRef, useState } from "react";
import { api, money } from "@/lib/api";
import { applicationErrorMessage } from "../lib/applicationErrors.mjs";

export default function ConsultationCancellation({ booking, onCancelled }) {
  const [confirming, setConfirming] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const pending = useRef(false);
  const cancel = async () => {
    if (pending.current) return;
    pending.current = true;
    setSaving(true);
    setMessage("");
    setError(false);
    try {
      const { data } = await api.post(`/consultations/bookings/${encodeURIComponent(booking.id)}/cancel`);
      if (data.ok !== true) throw new Error("Cancellation was not confirmed");
      onCancelled({ ...booking, status: "cancelled", refund_pence: data.refund_pence });
      setConfirming(false);
      setMessage(`Cancellation saved. ${data.warning || ""}`.trim());
    } catch (e) {
      setError(true);
      setMessage(applicationErrorMessage(e, "Unable to confirm cancellation. Refresh your bookings to check the saved status before trying again."));
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };
  return <div className="mt-2">
    {booking.status === "cancelled" && Number.isInteger(booking.refund_pence) && <p className="text-xs text-slate-600">Recorded refund amount: {money(booking.refund_pence)}. This does not confirm that money has been refunded.</p>}
    {booking.status === "confirmed" && !confirming && <button type="button" className="btn btn-ghost py-1 px-3" onClick={() => setConfirming(true)}>Cancel consultation</button>}
    {confirming && booking.status === "confirmed" && <div className="mt-2 rounded-lg border border-amber-200 bg-amber-50 p-3">
      <p>Cancel this consultation? Your slot will be released. The refund amount follows the cancellation policy; any money transfer requires finance processing.</p>
      <button type="button" className="btn btn-ghost mt-2" disabled={saving} onClick={() => setConfirming(false)}>Keep booking</button>
      <button type="button" className="btn btn-primary mt-2" disabled={saving} onClick={cancel}>{saving ? "Cancelling…" : "Confirm cancellation"}</button>
    </div>}
    {message && <p className={error ? "mt-2 text-sm text-red-700" : "mt-2 text-sm text-slate-600"} role={error ? "alert" : "status"}>{message}</p>}
  </div>;
}
